import "./index.scss";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { LiveInspectorData } from "types/types";
import { NewsEventsDetailProps } from "./types";
import { getTranslations } from "helpers/contenful";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import Breadcrumb from "components/Breadcrumb";
import EventBookingCta from "components/EventBookingCta";
import Map from "components/Map";
import NewsEventRelated from "components/NewsEventsRelated";
import PostFooter from "components/Post/PostFooter";
import PostHeader from "components/Post/PostHeader";
import React, { useMemo } from "react";
import recursiveRender from "utilities/recursiveRender";

const NewsEventsDetail = ({ page, breadcrumb }: NewsEventsDetailProps) => {
  const { node_locale, content, image, ...otherProps } = page.content[0];

  const {
    title,
    date,
    location,
    map,
    labelBookEvent,
    labelBookEventCollection,
    linkBookEvent,
  } = useContentfulLiveUpdates({
    ...otherProps,
    sys: { id: otherProps.contentful_id },
  });

  const liveInspector: LiveInspectorData = {
    postHeader: ContentfulLivePreview.getProps({
      entryId: page.content[0].contentful_id,
      fieldId: "entryTitle",
    }),
  };

  let eventCta: React.ReactNode = "";
  if (linkBookEvent?.[0]) {
    eventCta = (
      <EventBookingCta
        linkBookEvent={linkBookEvent?.[0]}
        labelBookEvent={
          labelBookEventCollection?.items
            ? { text: { text: labelBookEventCollection.items[0]?.text } }
            : labelBookEvent?.[0]
        }
      />
    );
  }

  const objTranslation = useMemo(() => {
    const translations = page?.settings[0]?.translations ?? [];
    return getTranslations(translations);
  }, [page]);

  return (
    <>
      <PostHeader
        date={date}
        location={location}
        image={image}
        title={title}
        liveInspector={liveInspector}
      />
      {breadcrumb && (
        <div className="newsEventDetail__breadcrumbs">
          <Breadcrumb {...breadcrumb} />
        </div>
      )}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10">
            {eventCta}
            {recursiveRender({ cfComponent: content })}
            {eventCta}
          </div>
        </div>
      </div>
      {map && (
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 mb--lg">
              <Map lat={map.lat ?? 0} lng={map.lon ?? 0} />
            </div>
          </div>
        </div>
      )}
      <PostFooter date={date} location={location} />
      <div className="newsEventDetail__related">
        <NewsEventRelated
          node_locale={node_locale}
          translations={{
            title: objTranslation["news-event-related-title"],
            text: objTranslation["news-event-related-text"],
            ctaLabel: objTranslation["view-all"],
          }}
        />
      </div>
    </>
  );
};

export default NewsEventsDetail;
